// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selector
import { getCurrentUserId } from '../../../../../../user/currentUserSelector';
import { getCurrentBoardNotificationPreference } from '../../../../../../notifications/preferences/boardNotificationPreferencesSelector';

// Actions
import { setBoardNotificationPreferences } from '../../../../../../notifications/preferences/boardNotificationPreferencesActions';

// Components
import ToggleInput from '../../../../../../components/form/fields/ToggleInput';

const mapStateToProps = createStructuredSelector({
    currentUserId: getCurrentUserId,
    currentBoardSubscribed: getCurrentBoardNotificationPreference,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchSetBoardNotificationPreferences: ({ userId, boardId, subscribed }) =>
        dispatch(setBoardNotificationPreferences({ userId, boardId, preferences: { subscribed } })),
});

@connect(mapStateToProps, mapDispatchToProps)
class BoardNotificationPreferenceToggle extends React.Component {
    onToggle = () => {
        const { currentBoardSubscribed, currentBoardId, currentUserId, dispatchSetBoardNotificationPreferences } =
            this.props;

        dispatchSetBoardNotificationPreferences({
            userId: currentUserId,
            boardId: currentBoardId,
            subscribed: !currentBoardSubscribed,
        });
    };

    render() {
        const { currentBoardSubscribed } = this.props;

        return (
            <div className="BoardNotificationPreferenceToggle">
                <ToggleInput active={currentBoardSubscribed} onChange={this.onToggle} />
            </div>
        );
    }
}

BoardNotificationPreferenceToggle.propTypes = {
    isGuest: PropTypes.bool,
    currentUserId: PropTypes.string,
    currentBoardId: PropTypes.string,
    currentBoardSubscribed: PropTypes.bool,

    dispatchSetBoardNotificationPreferences: PropTypes.func,
};

export default BoardNotificationPreferenceToggle;
